/**
 * InfinitSales - Transcription Service
 * Frontend client for /api/audio/transcribe-message and /api/audio/transcription-quota
 */
import api from './api';

const BASE = '/api/audio';

const transcriptionService = {
  /**
   * Request transcription of a chat audio message.
   *
   * @param {Object} params
   * @param {'wa-personal'|'wa-business'} params.channel
   * @param {string} params.messageId - wamid of the audio message
   * @param {string} [params.chatId]
   * @param {string} [params.mediaUrl]
   * @returns {Promise<{transcript:string, cached:boolean, current_count?:number, max_allowed?:number}>}
   * @throws {Error & {limitInfo?}} On 403 limit reached, attaches `limitInfo` with quota details.
   */
  async transcribeMessage({ channel, messageId, chatId, mediaUrl }) {
    try {
      const response = await api.post(`${BASE}/transcribe-message`, {
        channel,
        message_id: messageId,
        chat_id: chatId || null,
        media_url: mediaUrl || null,
      });
      return response.data;
    } catch (error) {
      const detail = error?.response?.data?.detail;
      if (error?.response?.status === 403 && detail?.code === 'transcription_limit_reached') {
        const wrapped = new Error(detail.message || 'Limite de transcrições atingido.');
        wrapped.limitInfo = detail;
        throw wrapped;
      }
      throw new Error(
        (typeof detail === 'string' && detail) ||
        detail?.message ||
        error?.message ||
        'Erro ao transcrever áudio'
      );
    }
  },

  /**
   * Fetch current monthly transcription quota for the logged-in user.
   *
   * @returns {Promise<{current_count:number, max_allowed:number, tier:string, tier_name:string, required_tier:string}>}
   */
  async getQuota() {
    const response = await api.get(`${BASE}/transcription-quota`);
    return response.data?.data || {
      current_count: 0,
      max_allowed: 0,
      tier: 'sales_free',
      tier_name: 'Free',
      required_tier: 'sales_pro',
    };
  },
};

export default transcriptionService;
